'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n\n  & > g > path:first-child {\n    fill: ', '\n  }\n\n  & > g > path:last-child {\n    fill: ', '\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n\n  & > g > path:first-child {\n    fill: ', '\n  }\n\n  & > g > path:last-child {\n    fill: ', '\n  }\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var SVG = _styledComponents2.default.svg(_templateObject, function (props) {
  if (props.order === "" || props.order === "ASC") {
    return props.theme['color_border-gray'] + ';';
  } else {
    return props.theme['color_dark-gray'] + ';';
  }
}, function (props) {
  if (props.order === "" || props.order === "DESC") {
    return props.theme['color_border-gray'] + ';';
  } else {
    return props.theme['color_dark-gray'] + ';';
  }
});
var OrderArrow = function (_PureComponent) {
  _inherits(OrderArrow, _PureComponent);
  function OrderArrow() {
    _classCallCheck(this, OrderArrow);
    return _possibleConstructorReturn(this, (OrderArrow.__proto__ || Object.getPrototypeOf(OrderArrow)).apply(this, arguments));
  }
  _createClass(OrderArrow, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SVG, Object.assign({}, this.props, {
        viewBox: '10 10 600 600'
      }), _react2.default.createElement('g', null, _react2.default.createElement('path', {
        d: 'M453.1,29.3v409.3l-76.6-76.6c-9.1-9.1-23.8-9.1-32.9,0c-9.1,9.1-9.1,23.8,0,32.9l116.4,116.4\r c9.1,9.1,23.8,9.1,32.9,0l116.4-116.4c4.5-4.5,6.8-10.5,6.8-16.5c0-6-2.3-11.9-6.8-16.5c-9.1-9.1-23.8-9.1-32.9,0l-76.6,76.6V29.3\r c0-12.9-10.4-23.3-23.3-23.3S453.1,16.4,453.1,29.3z'
      }), _react2.default.createElement('path', {
        d: 'M63.8,129.2c-9.1,9.1-9.1,23.8,0,32.9c9.1,9.1,23.8,9.1,32.9,0l76.6-76.6v409.3\r c0,12.9,10.4,23.3,23.3,23.3c12.9,0,23.3-10.4,23.3-23.3V85.5l76.6,76.6c9.1,9.1,23.8,9.1,32.9,0c4.5-4.5,6.8-10.5,6.8-16.5\r c0-6-2.3-11.9-6.8-16.5L213.1,12.8c-9.1-9.1-23.8-9.1-32.9,0L63.8,129.2z'
      })));
    }
  }]);
  return OrderArrow;
}(_react.PureComponent);
exports.default = OrderArrow;